import React, { FC } from 'react';
import { Controls1 } from "@ews/react-data";
import s from '../SystemDocumentation.module.scss';
import { DisplaySettings } from '@ews/react-data';

const TableControls1: FC<{ data: Controls1, displaySettings: DisplaySettings; }> = ({ data, displaySettings }) =>
{
    if (!data) return <>no data</>;

    const columnsCount =
        3 +
        Number(displaySettings.displayTechnicalMessage ? 1 : 0) +
        Number(displaySettings.displayPreAlarm ? 1 : 0) +
        Number(displaySettings.displayFaultAlarm ? 1 : 0);

    const colWidth = 100 / columnsCount;

    return (
        <table
            id="system-documentation-controls1"
            data-name="Steuerungen1"
            className={s.table}
        >
            <thead>
                <tr>
                    <th style={{ width: "160px" }}></th>
                    <th style={{ width: "160px" }}></th>
                    <th style={{ width: "120px" }}></th>

                    {Array.from({ length: columnsCount }).map((_, i) => (
                        <th key={i} style={{ width: `${colWidth}px` }}></th>
                    ))}

                    <th style={{ width: "330px" }}></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className={`${s.bT} ${s.bL} ${s.bR} ${s.title}`} colSpan={columnsCount + 3}>
                        Brandmeldeanlage
                    </td>
                    <td className={`${s.b} ${s.title}`}>TRVB 123 S</td>
                </tr>

                <tr>
                    <td
                        className={`${s.bB} ${s.bL} ${s.bR} ${s.title} ${s.bold}`}
                        colSpan={columnsCount + 3} rowSpan={2}
                    >
                        Steuerungen
                    </td>
                    <td className={`${s.bR} ${s.title}`}>Anhang 1</td>
                </tr>

                <tr>
                    <td colSpan={columnsCount + 3} className={`${s.bR} ${s.title}`}>StGV 1</td>
                </tr>

                <tr>
                    <td rowSpan={2} className={`${s.bold} ${s.b} ${s.tC} ${s.aM}`}>
                        Steuergruppen Nr. Zusatzangabe für überwachte STG
                    </td>
                    <td colSpan={2} rowSpan={2} className={`${s.b} ${s.tC} ${s.aM}`}>
                        Bezeichnung (Art der Steuerung)
                    </td>
                    <td colSpan={columnsCount} className={`${s.b} ${s.tC} ${s.aM}`}>
                        angesteuert bei
                    </td>
                    <td rowSpan={2} className={`${s.b} ${s.tC} ${s.aM}`}>
                        angesteuert von BG (Melder) / Eingang
                    </td>
                </tr>

                <tr>
                    <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>Alarm</td>
                    {displaySettings.displayPreAlarm && (
                        <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>PreAlarm</td>
                    )}
                    {displaySettings.displayTechnicalMessage && (
                        <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>TM</td>
                    )}
                    {displaySettings.displayFaultAlarm && (
                        <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>StörAlarm</td>
                    )}
                    <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>Absch.</td>
                    <td className={`${s.vertical} ${s.b} ${s.aC} ${s.tL}`}>Stör.</td>
                </tr>

                {/* === Übertragungseinrichtungen === */}
                <tr>
                    <td
                        colSpan={columnsCount + 4}
                        className={`${s.b} ${s.bL} ${s.bR} ${s.tC} ${s.aM} ${s.greyRow}`}
                    >
                        Übertragungseinrichtungen
                    </td>
                </tr>

                {Object.entries(data[3]).map(([key, value]) =>
                {
                    const act = value.actuation;
                    if ("from" in act) {
                        const placeholder = act as { from: number; to: number; };
                        return (
                            <tr className={s.greyRow} key={key}>
                                <td className={`${s.b} ${s.tL} ${s.aM}`}>Reserve</td>
                                <td colSpan={2} className={`${s.b} ${s.tL} ${s.aM}`}>
                                    {placeholder.from} – {placeholder.to}
                                </td>
                                {Array.from({ length: columnsCount + 1 }).map((_, i) => (
                                    <td key={i} className={`${s.b} ${s.tC} ${s.aM}`}></td>
                                ))}
                            </tr>
                        );
                    }
                    return act.zones.map((item, idx) => (
                        <tr key={`${key}-${idx}`}>
                            {idx === 0 && (
                                <td rowSpan={act.zones.length} className={`${s.b} ${s.tL} ${s.aM}`}>
                                    {act.title}
                                </td>
                            )}
                            {idx === 0 && (
                                <td
                                    colSpan={2}
                                    rowSpan={act.zones.length}
                                    className={`${s.b} ${s.tL} ${s.aM}`}
                                >
                                    {act.description}
                                </td>
                            )}
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Alarm"] ? "X" : ""}
                            </td>
                            {displaySettings.displayPreAlarm && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["PreAlarm"] ? "X" : ""}
                                </td>
                            )}
                            {displaySettings.displayTechnicalMessage && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["TechnicalMessage"] ? "X" : ""}
                                </td>
                            )}
                            {displaySettings.displayFaultAlarm && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["FaultAlarm"] ? "X" : ""}
                                </td>
                            )}
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Shutdown"] ? "X" : ""}
                            </td>
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Fault"] ? "X" : ""}
                            </td>
                            <td className={`${s.b} ${s.tL} ${s.aM}`}>{item.text}</td>
                        </tr>
                    ));
                })}

                {/* === Alarmierungseinrichtungen === */}
                <tr>
                    <td
                        colSpan={columnsCount + 4}
                        className={`${s.b} ${s.bL} ${s.bR} ${s.tC} ${s.aM} ${s.greyRow}`}
                    >
                        Alarmierungseinrichtungen
                    </td>
                </tr>

                {Object.entries(data[2]).map(([key, value]) =>
                {
                    const act = value.actuation;
                    if ("from" in act) {
                        const placeholder = act as { from: number; to: number; };
                        return (
                            <tr className={s.greyRow} key={key}>
                                <td className={`${s.b} ${s.tL} ${s.aM}`}>Reserve</td>
                                <td colSpan={2} className={`${s.b} ${s.tL} ${s.aM}`}>
                                    {placeholder.from} – {placeholder.to}
                                </td>
                                {Array.from({ length: columnsCount + 1 }).map((_, i) => (
                                    <td key={i} className={`${s.b} ${s.tC} ${s.aM}`}></td>
                                ))}
                            </tr>
                        );
                    }
                    return act.zones.map((item, idx) => (
                        <tr key={`${key}-${idx}`}>
                            {idx === 0 && (
                                <td rowSpan={act.zones.length} className={`${s.b} ${s.tL} ${s.aM}`}>
                                    {act.title}
                                </td>
                            )}
                            {idx === 0 && (
                                <td
                                    colSpan={2}
                                    rowSpan={act.zones.length}
                                    className={`${s.b} ${s.tL} ${s.aM}`}
                                >
                                    {act.description}
                                </td>
                            )}
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Alarm"] ? "X" : ""}
                            </td>
                            {displaySettings.displayPreAlarm && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["PreAlarm"] ? "X" : ""}
                                </td>
                            )}
                            {displaySettings.displayTechnicalMessage && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["TechnicalMessage"] ? "X" : ""}
                                </td>
                            )}
                            {displaySettings.displayFaultAlarm && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["FaultAlarm"] ? "X" : ""}
                                </td>
                            )}
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Shutdown"] ? "X" : ""}
                            </td>
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Fault"] ? "X" : ""}
                            </td>
                            <td className={`${s.b} ${s.tL} ${s.aM}`}>{item.text}</td>
                        </tr>
                    ));
                })}

                {/* === Steuerungen (data[1]) === */}
                <tr>
                    <td
                        colSpan={columnsCount + 4}
                        className={`${s.b} ${s.bL} ${s.bR} ${s.tC} ${s.aM} ${s.greyRow}`}
                    >
                        Steuerungen
                    </td>
                </tr>

                {Object.entries(data[1]).map(([key, value]) =>
                {
                    const act = value.actuation;
                    if ("from" in act) {
                        const placeholder = act as { from: number; to: number; };
                        return (
                            <tr className={s.greyRow} key={key}>
                                <td className={`${s.b} ${s.tL} ${s.aM}`}>Reserve</td>
                                <td colSpan={2} className={`${s.b} ${s.tL} ${s.aM}`}>
                                    {placeholder.from} – {placeholder.to}
                                </td>
                                {Array.from({ length: columnsCount + 1 }).map((_, i) => (
                                    <td key={i} className={`${s.b} ${s.tC} ${s.aM}`}></td>
                                ))}
                            </tr>
                        );
                    }
                    return act.zones.map((item, idx) => (
                        <tr key={`${key}-${idx}`}>
                            {idx === 0 && (
                                <td rowSpan={act.zones.length} className={`${s.b} ${s.tL} ${s.aM}`}>
                                    {act.title}
                                </td>
                            )}
                            {idx === 0 && (
                                <td
                                    colSpan={2}
                                    rowSpan={act.zones.length}
                                    className={`${s.b} ${s.tL} ${s.aM}`}
                                >
                                    {act.description}
                                </td>
                            )}
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Alarm"] ? "X" : ""}
                            </td>
                            {displaySettings.displayPreAlarm && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["PreAlarm"] ? "X" : ""}
                                </td>
                            )}
                            {displaySettings.displayTechnicalMessage && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["TechnicalMessage"] ? "X" : ""}
                                </td>
                            )}
                            {displaySettings.displayFaultAlarm && (
                                <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                    {item.controlType["FaultAlarm"] ? "X" : ""}
                                </td>
                            )}
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Shutdown"] ? "X" : ""}
                            </td>
                            <td className={`${s.b} ${s.tC} ${s.aM}`}>
                                {item.controlType["Fault"] ? "X" : ""}
                            </td>
                            <td className={`${s.b} ${s.tL} ${s.aM}`}>{item.text}</td>
                        </tr>
                    ));
                })}
            </tbody>
        </table>
    );
};

export default TableControls1;
